import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/ephemeral-jobs')({
  component: () => <Navigate replace search to="/bo/ephemeral-jobs" />,
})
